import m from 'mithril';
import demoModal from './modals/demo';
import validationDemo from './modals/validationDemo';

export default {
  oninit: ({state, attrs}) => {
    let currentPosition = document.body.scrollHeight <= window.innerHeight ? "fixed" : "relative";
    if (state.position !== currentPosition) {
      state.position = currentPosition;
    }

    setInterval(() => {
      const newPosition = document.body.scrollHeight <= window.innerHeight ? "fixed" : "relative";
      if (state.position !== newPosition) {
        state.position = newPosition;
          m.redraw();
      }
    }, 50);
  },
  view({state,attrs}) {
    console.log(document.body.scrollHeight, window.innerHeight)
    return m("div", {
      "class": "app-footer",
      "id": "kt_app_footer",
      style: {
        position: "absolute",
        bottom: 0,
        width: "100%",
        height: "auto",
        position:state.position,
      }
    },
      m("div", { "class": "app-container container-fluid d-flex flex-column flex-md-row flex-center flex-md-stack py-3" },
        [
          m("div", { "class": "text-gray-900 order-2 order-md-1" },
            [
              m("span", { "class": "text-muted fw-semibold me-1" },
                "2024©"
              ),
              m("a", { "class": "text-gray-800 text-hover-primary", "href": "#", "target": "_blank" },
                "Branson"
              )
            ]
          ),
          m("ul", { "class": "menu menu-gray-600 menu-hover-primary fw-semibold order-1" },
            [
              m("li", { "class": "menu-item" },
                m("a", { "class": "menu-link px-2", "href": "#", "target": "_blank" },
                  "Version: v0.8.1"
                )
              ),
              m("li", { "class": "menu-item" },
                m("a", { "class": "menu-link px-2", "href": "#", "target": "_blank" },
                  "QA ENV"
                )
              )
            ]
          )
        ]
      )
    )
  }
};
